/*global _*/
//@flow

class AppMenuCtrl {

	constructor() {
		const self = this;
		//Inject Helper
		let injectHelper = _.object(AppMenuCtrl.$inject, arguments);
		Object.assign(self, injectHelper);

		//Default State
		const defaultHelper = {
			menuOptions: {
				rules: {
					ISADMIN(): boolean {
						return true;
					}
				}
			}
		};
		Object.assign(self, defaultHelper);
	}

}

AppMenuCtrl.$inject = [];
export default AppMenuCtrl;
